module.exports = __webpack_public_path__ + "static/media/travicar_TT03.9771deba.png";